// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1HpTa","content":"GlobalSearch_content__3C7uI"};